import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import UtilisateurListeTableRow from './UtilisateurListeTableRow';

type SortsType = {
  nom?: 'asc' | 'desc';
};

const UtilisateurListeTable = (props) => {
  const { items, loading, onSelect, selected } = props;

  const [sorts, setSorts] = React.useState<SortsType>({});

  const handleSort = React.useCallback(
    (sort) => {
      setSorts(
        _.isEmpty(sort)
          ? // tri par défaut
            { nom: 'asc' }
          : { nom: sort?.nom === 'ascending' ? 'asc' : 'desc' },
      );
    },
    [setSorts],
  );

  const renderRow = (item, __, rowProps) => (
    <UtilisateurListeTableRow item={item} rowProps={rowProps} />
  );

  const formatedUsers = React.useMemo(
    () =>
      _.map(items, ({ nom, prenom, ...rest }) => ({
        nom: _.upperFirst(_.toLower(nom)),
        prenom: _.upperFirst(_.toLower(prenom)),
        ...rest,
      })),
    [items],
  );

  const sortedUsers = React.useMemo(
    () => _.orderBy(formatedUsers, ['nom', 'prenom'], [sorts?.nom, 'asc']),
    [formatedUsers, sorts],
  );

  return (
    <div style={{ height: 250 }}>
      <ListeTable
        count={_.size(sortedUsers)}
        items={_.orderBy(sortedUsers, sorts)}
        loading={loading}
        onSort={handleSort}
        selection="click"
        onSelect={onSelect}
        selectedItems={selected ? [selected] : []}
      >
        <ListeTable.Header>
          <ListeTable.Column name="nom" sortable width={16}>
            Liste des utilisateurs disponibles
          </ListeTable.Column>
        </ListeTable.Header>
        {renderRow as unknown as ReactNode}
      </ListeTable>
    </div>
  );
};

export default UtilisateurListeTable;
